import isEmpty from "src/lib/isEmpty";
import formatCurrency from "src/lib/format-currency";

function getRedemptionsText(redemptions) {
  if (redemptions === null) {
    return "all your subscription deliveries";
  }

  if (redemptions > 1) {
    return `your first ${redemptions} subscription deliveries`;
  }

  return "your first subscription delivery";
}

function getDiscountAmount(discountAmountType, discountAmount) {
  if (discountAmountType === "absolute" && discountAmount > 0) {
    return formatCurrency({ value: discountAmount });
  }

  if (discountAmountType === "percentage") {
    return `${discountAmount}%`;
  }

  return null;
}

export const generateCouponMessage = (couponData = {}) => {
  const { code, ...couponDataSanCode } = couponData;
  const redemptionsText = getRedemptionsText(couponData.max_redemptions);
  const discountAmountType = couponData.discount_amount_type;
  const discountAmount = getDiscountAmount(
    discountAmountType,
    couponData.discount_amount
  );

  if (
    isEmpty(couponDataSanCode) ||
    (discountAmountType !== "absolute" && discountAmountType !== "percentage")
  ) {
    return null;
  }

  if (couponData.expired === true) {
    return "This coupon has expired.";
  }

  return `Congratulations - you've got ${discountAmount} off ${redemptionsText}`;
};
